import { AppProviders } from '@/app/providers';
import { AppRouter } from '@/app/router';
import { PwaUpdateBanner } from '@/features/pwa/PwaUpdateBanner';

export function App() {
  return (
    <AppProviders>
      <AppRouter />
      <PwaUpdateBanner />
    </AppProviders>
  );
}

export default App;
